import React from 'react'
import styled from 'styled-components'

// Components
import { StatList, S_StatList } from '../../../../_components/StatList'

export const S_ScheduleSummary = styled.div`
  ${S_StatList} {
    margin-bottom: 20px;
  }
`

const stateMapping = {
  incomplete: 'Incomplete',
  rejected: 'Not Funded',
  pending: 'Pending',
  approved: 'Approved',
  purchased: 'Purchased',
}

export const ScheduleSummary = ({ schedule, business }) => {
  if (!schedule || !business) {
    return null
  }

  const summaryItems = [
    {
      label: 'Client',
      value: business?.business_name || '',
      type: 'text',
    },
    {
      label: 'Invoice Total',
      value: schedule?.total_value || '',
      type: 'currency',
    },
    {
      label: 'Funding Total',
      value: schedule?.total_funded || '',
      type: 'currency',
    },
    {
      label: 'Status',
      value: schedule?.state ? stateMapping[schedule.state] : '',
      type: 'text',
    },
  ]

  return (
    <S_ScheduleSummary>
      <StatList className="inline" items={summaryItems} />
    </S_ScheduleSummary>
  )
}
